import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {DeleteModal, SelectMain, SimpleTabs} from "components";
import {AddNotes, allStatusesList, History, MainDetails, Notes, ResetPassword} from "fragments";
import {employeeDetails} from "./constants";
import {useModal, usePrimaryModal} from "utils";
import {employeesActions} from "store";
import {Svg} from "assets";

const tabsLabels = [{label: "Details"}, {label: "Notes"}, {label: "History"}];
const ACTION_DELETE = "DELETE_EMPLOYEES";

export const EmployeesSingle = ({item}) => {
    const {notesList} = useSelector((state) => ({
        notesList: state.notes.notesList,
    }));
    const {control, setValue} = useForm();
    const dispatch = useDispatch();
    const {close} = useModal();
    const {openPrimary, closePrimary} = usePrimaryModal();

    useEffect(() => {
        if (item?.status) {
            setValue('status', item?.status)
        }
    }, [item?.status]);


    const handleResetPassword = () => {
        openPrimary(
            <ResetPassword id={item?.id} ifEmploy/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 508
            },
        );
    }

    const payerDetailsTabContent = [
        {
            tabComponent: <MainDetails
                AnotherBlock={
                    <div className='details-reset-password-wrapper'>
                        <button
                            type='button'
                            className='details-reset-password-btn'
                            onClick={handleResetPassword}
                        >
                            <Svg.LockPassSvg/>
                            Reset Password
                        </button>
                    </div>
                } info={employeeDetails(item)}/>,
            tab: "Details",
        },

        {
            tabComponent: <Notes currentId={item?.id} onResource="employee"/>,
            tab: "Notes",
        },

        {
            tabComponent: <History
                currentId={item?.id}
                notDescText="No changes have been recorded for this employee yet."
            />,
            tab: "History",
        },
    ];

    const changeStatus = (status) => {
        dispatch(employeesActions.changeStatus(item?.id, {status}))
    }

    const handleDelete = () => {
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(employeesActions.deleteEmployee(item?.id));
                }}
                handleCancel={closePrimary}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove ${item?.name} ?`}
                afterSuccess={() => {
                    close();
                    closePrimary();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const handleAddNote = () => {
        openPrimary(<AddNotes onResource="employee" currentId={item?.id}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 1276
        });
    };

    const handelTextButton = (currentTab) => {
        return currentTab === "Notes" && notesList?.length ? "Add Note" : "";
    };

    const handleAdd = (currentNote) => {
        return currentNote === "Notes" && handleAddNote;
    };

    return (
        <div className="employees-single-wrapper">
            <div className="modal-header-main">
                <h2 className="modal-header-title">{item?.firstName}</h2>

                <div className="align-center" style={{gap: 8}}>
                    <div style={{minWidth: 145}}>
                        <SelectMain
                            list={allStatusesList}
                            renderLabel={(option) => option.name}
                            name='status'
                            control={control}
                            placeholder="Status"
                            selectedValue={'id'}
                            allowError={false}
                            disableClearable
                            handleChange={changeStatus}
                        />
                    </div>

                    {/*<button className="reset-btn" onClick={handleDelete}>*/}
                    {/*  <Svg.TrashSvg />*/}
                    {/*</button>*/}

                    <button
                        className="modal-close-btn-main"
                        type="button"
                        onClick={close}
                    >
                        <Svg.CloseSvg/>
                    </button>
                </div>
            </div>

            <div className="modal-body-main">
                <SimpleTabs
                    tabsLabels={tabsLabels}
                    tabsContent={payerDetailsTabContent}
                    defaultTab="Details"
                    pushToHistory={false}
                    handelTextButton={handelTextButton}
                    handleAdd={handleAdd}
                />
            </div>
        </div>
    );
};
